import { Box, Paper, Typography, Skeleton } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import {
  MapOutlined,
  DescriptionOutlined,
  ScheduleOutlined,
  RouterOutlined,
} from "@mui/icons-material";
import { sumLength } from "./utils";

export default function SummaryStrip({
  access,
  recentMaps = [],
  mapsSummary = null,
  reports = [],
  reportsTotal = null,
  schedulesCount = 0,
  loading = false,
}) {
  const theme = useTheme();
  const success = theme.palette.sucess?.main || theme.palette.success.main;

  const items = [];

  if (access?.easyMaps) {
    // os totais vêm de todos os mapas do cliente (/easyMaps/map/summary);
    // a lista de recentes é só o fallback se o resumo não responder
    items.push({
      label: "Mapas cadastrados",
      value: mapsSummary?.totalMaps ?? recentMaps.length,
      icon: <MapOutlined />,
      color: theme.palette.primary.main,
    });
    items.push({
      label: "Hosts monitorados",
      value: mapsSummary?.totalHosts ?? sumLength(recentMaps, "hosts"),
      icon: <RouterOutlined />,
      color: theme.palette.info.main,
    });
  }

  if (access?.easyReport) {
    items.push({
      label: "Relatórios gerados",
      // reports traz só os recentes; o total vem separado da API
      value: reportsTotal ?? reports.length,
      icon: <DescriptionOutlined />,
      color: "#F48206",
    });
    items.push({
      label: "Relatórios agendados",
      value: schedulesCount,
      icon: <ScheduleOutlined />,
      color: success,
    });
  }

  if (items.length === 0) return null;

  const styles = {
    grid: {
      display: "grid",
      gridTemplateColumns: {
        // no mobile empilha em coluna única — em 2 colunas o valor e o rótulo
        // ficam apertados demais ao lado do ícone
        xs: "1fr",
        sm: "repeat(2, 1fr)",
        lg: `repeat(${Math.min(items.length, 5)}, 1fr)`,
      },
      gap: 2,
      width: "100%",
    },
    card: {
      p: 1.75,
      borderRadius: 2,
      display: "flex",
      alignItems: "center",
      gap: 1.5,
      bgcolor: theme.palette.background.paper,
      boxShadow: "0px 1px 3px rgba(0,0,0,0.05)",
      transition: "transform .18s ease, box-shadow .18s ease",
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0px 8px 18px rgba(0,0,0,0.08)",
      },
    },
    iconBox: (color) => ({
      width: 42,
      height: 42,
      borderRadius: 1.5,
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color,
      background: `linear-gradient(135deg, ${alpha(color, 0.18)}, ${alpha(
        color,
        0.08,
      )})`,
    }),
    value: { fontSize: "1.35rem", fontWeight: 700, lineHeight: 1.1 },
    label: { fontSize: "0.8rem", color: theme.palette.text.secondary },
  };

  return (
    <Box sx={styles.grid}>
      {items.map((item) => (
        <Paper key={item.label} sx={styles.card} elevation={0}>
          <Box sx={styles.iconBox(item.color)}>{item.icon}</Box>
          <Box sx={{ minWidth: 0 }}>
            {loading ? (
              <Skeleton width={40} height={30} />
            ) : (
              <Typography sx={styles.value}>
                {Number(item.value || 0).toLocaleString("pt-BR")}
              </Typography>
            )}
            <Typography sx={styles.label} noWrap>
              {item.label}
            </Typography>
          </Box>
        </Paper>
      ))}
    </Box>
  );
}
